import React, { ReactNode } from 'react';

import cx from 'classnames';
import useIntersectionObserver from 'themes/canvas/components/IntersectionObserverHook';

import s from './CanvasAnimatedTile.module.css';

interface CanvasAnimatedTileProps {
  children: ReactNode;
  threshold?: number;
  className?: string;
}

export const CanvasAnimatedTile: React.FC<CanvasAnimatedTileProps> = ({
  children,
  threshold = 0.3,
  className = '',
}) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: threshold,
  });

  return (
    <div
      ref={ref}
      className={cx(
        s.animateIn,
        { [s.visible]: isVisible },
        className && s[className],
      )}
    >
      {children}
    </div>
  );
};
